
import { defineComponent } from 'vue'

const afterShowModal = () => {
  const body = document.body
  const scrollY = window.scrollY
  body.style.position = 'fixed'
  body.style.top = `-${scrollY}px`
  body.style.left = '0'
  body.style.right = '0'
}

const afterCloseModal = () => {
  const body = document.body
  const scrollY = body.style.top
  body.style.position = ''
  body.style.top = ''
  window.scrollTo(0, parseInt(scrollY || '0') * -1)
}

export default defineComponent({
  name: 'ModalComponent',

  data () {
    return {
      showModal: false,
      isSaveLaterModal: false
    }
  },

  props: {
    showCloseButton: {
      type: Boolean,
      default: true
    },
    backdropDismiss: {
      type: Boolean,
      default: true
    },
    useOverflowStyle: {
      type: Boolean,
      default: false
    },
    isFullScreenMobile: {
      type: Boolean,
      default: false,
      required: false
    },
    width: {
      type: String,
      required: false,
      default: 'auto'
    },
    height: {
      type: String,
      required: false,
      default: 'auto'
    }
  },

  emits: ['onClose'],

  methods: {
    toggle () {
      if (this.showModal) {
        this.close()
      } else {
        this.open()
      }
    },

    open () {
      this.showModal = true
      this.$nextTick(() => {
        afterShowModal()
      })
    },

    close () {
      this.showModal = false
      this.$nextTick(() => {
        afterCloseModal()
        this.$emit('onClose')
      })
    },
    checkIfSaveLaterModal () {
      const isSaveLaterModal = sessionStorage.getItem('isSaveLaterModal') || ''
      this.isSaveLaterModal = isSaveLaterModal.length > 0
      sessionStorage.removeItem('isSaveLaterModal')
    }
  },
  created () {
    this.checkIfSaveLaterModal()
  }
})
